import type { PersonFeature } from '@app/shared'

/**
 * The Studio features the signed-in person has switched on, held where a
 * route's guard can read it. A guard runs outside React, so it cannot ask a
 * query; the auth provider writes this as it renders, before anything it
 * gates is drawn, and every reader that draws must read the auth context too
 * so it draws again when a switch moves.
 */
let switchedOn: readonly PersonFeature[] = []

export function holdFeatures(features: readonly PersonFeature[]): void {
  switchedOn = features
}

export function featureOn(feature: PersonFeature): boolean {
  return switchedOn.includes(feature)
}
